import * as utils from "../utils/utils.js";

export default function (theme, themeOpts) {
  const widgetName = theme;
  const widgetOpts = themeOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    maxItemsVisible: 8,
    itemsPerPanel: 1,
    hasImages: true,
    imageIsBackground: true,
    textOverImage: true,
    showDescription: true,
    lazyLoadImages: false,
    buyNowButton: false,
    link: utils.checkWindowsSize(800) ? ["all"] : [""],
    moreButton: {
      visible: true,
      text: "More",
    },

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (!hasData) {
        $(`#${widgetName}`).parent().parent().remove();
      } else {
        customCardsHelper(data.items);
      }
    },
  });

  function customCardsHelper(widgetData) {
    $(`#${widgetName} .card-widget-item`).prepend(
      '<div class="overlay"></div>'
    );

    if (utils.checkWindowsSize(800)) {
      $(`#${widgetName} .card-widget-item`).find(".buttonwrap").remove();
      $(`#${widgetName} .card-widget-item`)
        .find(".card-widget-description")
        .remove();
      $(`#${widgetName} .card-widget-item`).find(".overlay").remove();
    }

    $(`#${widgetName} .card-widget-item`).each(function (x) {
      const { URL } = widgetData[x];

      $(this)
        .find(".buttonwrap .moreButton")
        .addClass("button")
        .removeClass("moreButton");

      if (utils.checkWindowsSize(800) && URL == null) {
        $(this).removeAttr("href");
      }

      validateYesteryearLayout();
      validateAgZoneLayout();

      if (URL == null) {
        $(this).addClass("voidLink");
        $(this).find(".buttonwrap").remove();
      }
    });
  }

  function validateYesteryearLayout() {
    if (widgetName == "yyCardWidget") {
      $(`#${widgetName} .card-widget-item`).each(function (x) {
        let titleSize = $(this).find(".card-widget-title").width();
        if (titleSize < 170) {
          $(this).find(".card-widget-title").addClass("small");
        }
      });
    }
  }

  function validateAgZoneLayout() {
    if (widgetName == "agZoneCardWidget") {
      $(`#${widgetName}`).find(".card-widget-description").remove();
    }
  }
}
